import request from '../utils/request.util'

export default {
  create (params) {
    return request.post('/otp-to-number', params)
  }
}
